export default __webpack_public_path__ + "a8de16a43e1a29ae9d0979b66bc7f7c4.wav";